import { useAppSelector } from 'app/hooks';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, isSupported, onMessage } from 'firebase/messaging';
import { showPushNotification } from 'modules/alert/utils';
import NotificationPopUp from 'modules/notification/NotificationPopUp';
import { useSendDeviceTokenMutation } from 'modules/notification/notificationApi';
import { selectUnreadCount } from 'modules/notification/slice';
import { useEffect } from 'react';
import { ENV, isITAREnvironment } from '../constants/env';

const firebaseConfig = {
  apiKey: ENV.VITE_FIREBASE_API_KEY,
  authDomain: ENV.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: ENV.VITE_FIREBASE_PROJECT_ID,
  storageBucket: ENV.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: ENV.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: ENV.VITE_FIREBASE_APP_ID,
  measurementId: ENV.VITE_FIREBASE_MEASUREMENT_ID,
};

const usePushNotifications = () => {
  const count = useAppSelector(selectUnreadCount);
  const [sendDeviceToken] = useSendDeviceTokenMutation();

  const initializeMessaging = async () => {
    if (ENV.NODE_ENV === 'test' || isITAREnvironment() || !(await isSupported())) return;

    try {
      const app = initializeApp(firebaseConfig);
      const messaging = getMessaging(app);
      const permission = await Notification.requestPermission();

      if (permission !== 'granted') return;

      const token = await getToken(messaging, {
        vapidKey: ENV.VITE_FIREBASE_VAPID_KEY,
      });
      // send token to backend
      if (token) sendDeviceToken({ registrationId: token, type: 'web' });
      // This is where we show the in app notification
      onMessage(messaging, (payload) => {
        showPushNotification(<NotificationPopUp messagePayload={payload} />);
      });
    } catch (error) {
      console.error('Failed to initialise Firebase Messaging');
    }
  };

  useEffect(() => {
    initializeMessaging();
  }, []);

  useEffect(() => {
    document.title = count > 0 ? `(${count}) 🔴 New Notification  | Threads` : 'Threads';
  }, [count]);
};

export default usePushNotifications;
